import classnames from 'classnames';
import React from 'react';

import { PlainHtmlButton } from '../common/plainHtmlButton/PlainHtmlButton';

interface Props {
  selected: boolean;
  disabled: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  onClick: () => void;
}

export const RadioButton = React.forwardRef<HTMLLabelElement, Props>(
  ({ selected, disabled, title, description, onClick }: Props, ref) => {
    return (
      <label aria-label="radio-button" ref={ref}>
        <PlainHtmlButton
          className={classnames(
            'flex w-full flex-row rounded border p-2 text-left text-base',
            selected ? 'border-blue bg-blue-lightest' : 'border-silver-darker',
            disabled ? 'cursor-default opacity-50' : 'hover:bg-blue-lightest',
          )}
          aria-disabled={disabled}
          onClick={() => {
            // we can't use the button's disabled prop as we would like to
            // because it makes the Tooltip moot if the Button is disabled
            if (!disabled) onClick();
          }}
        >
          <div
            className={classnames(
              'mr-2 mt-2 size-2 flex-none rounded',
              selected ? 'bg-blue' : 'border border-silver-darker',
            )}
          />
          <div>
            <span className="capitalize">{title}</span>
            {description && (
              <div className="text-sm text-secondary">{description}</div>
            )}
          </div>
        </PlainHtmlButton>
      </label>
    );
  },
);
